import React from 'react';

export const SubscriptionBillingMsg=({item})=>{

    if(!item) return <></>;
    let interval = item?.bill_interval || "";
    let intervalQty = +item?.interval_quantity || 0;
    if(!interval && !intervalQty) return <></>;
    
    let numTimes = item?.bill_num_times || null;
    let price = +item?.price || 0;
    let subType = item?.subscription_type_name || "";
    let activationFee = +item?.activation_fee || 0;
    let maxUsers = +item?.subscription_max_users || 0;
    
    console.log( numTimes, price, subType, activationFee, maxUsers)

    return(
        <div>
            {activationFee > 0 ?
                <>
                    (+ ${price} activation fee)
                </>
                :
                "Subscription "
            }
            {interval && interval ==="m" &&
                <>
                    {intervalQty > 1 ?
                        `billed every ${intervalQty} month${intervalQty > 1 ? "s" : ""}`
                        :
                        "billed monthly"
                    }
                    {numTimes ?
                        <>
                            {" "}{`${numTimes} time${numTimes > 1 ? "s" : ""} in total`}
                        </>
                        :
                        <>
                            {" "}until cancelled
                        </>
                    }
                </>
            }
            {interval && interval === "y" &&
                <>
                    {numTimes ?
                        " billed on purchase and will not recur"
                        :
                        " billed annually until cancelled"
                    }
                </>
            }
            <p>
                {subType &&
                    <>
                        - {subType} Subscription
                    </>
                }
                {maxUsers > 1 ?
                    ` (max users: ${maxUsers}).`
                    :
                    ``
                }
            </p>
            
        </div>
    )
}